import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/bikaner.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from 'react-helmet';
const Bikaner = () => {
  return (
    <>
      <Helmet>
        <title>Bikaner, Rajasthan - The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Discover the historic city of Bikaner in Rajasthan, India with The Rustic Paths. Immerse yourself in the rich cultural heritage, visit iconic landmarks, and experience the unique charm of Bikaner. Plan your journey with our private driver services and explore the beauty of Bikaner's architecture and traditions."
        />
        <meta
          name="keywords"
          content="Bikaner, Rajasthan, private driver, cultural heritage, landmarks, architecture, traditions"
        />
        <meta name="author" content="The Rustic Paths" />


  
      </Helmet>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Bikaner</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Bika Ki Tekri (Old Fort) </li>
                      <li>Junagarh Fort</li>
                      <li>Lalgarh Palace</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Bikaner
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Rao Bikaji, a Rathore prince, founded the city of Bikaner in
                    1488. Bikaji was one of the sons of Rao Jodhaji, the founder
                    of Jodhpur. The legend has it that Bikaji was provoked to
                    set up his own kingdom when his father commented him about
                    whispering in the royal durbar. Thereafter, he started
                    building up his own territory to the north of Jodhpur. His
                    first attention went to sterile wilderness called Jangladesh
                    and he converted it to a remarkable city. By the time Bikaji
                    died in 1504, he had extended his kingdom over 3000
                    villages. The modern Bikaner, as we see today got prospered
                    under the reign of Maharaja Ganga Singh. Read on this
                    Bikaner city guide to know more about the city:
                  </p>
                  <p>
                    Bikaner lies in the north of Rajasthan on a little elevated
                    ground. A 7 km long besieged wall, having five gates,
                    surrounds the city. Speckled with sand dunes, Bikaner
                    occupied an important position on the ancient caravan
                    routes. It served as a prime trading center to the merchants
                    coming from West/Central Asia. Bikaner travel & tourism
                    brings you across some splendid forts and palaces that serve
                    as a legacy of the rich heritage of the city. Built up in
                    red sandstone, these forts and palaces bring alive the
                    architectural finery in which the state of Rajasthan
                    abounds.
                  </p>

                  <p>
                    Bikaner in Rajasthan, India is still preserving the medieval
                    magnificence that was once the hallmark of the state. Along
                    with the amazing structures of the city, it is the cheerful
                    people that further enhance the attractiveness of the city.
                    Bikaner also houses one of the largest Camel research and
                    breeding farms in the world. It is renowned for providing
                    best riding camels in the world. Apart from that the Bikaner
                    fair also attracts a number of tourists. A trip to Bikaner
                    will leave you mesmerized with the grandeur of the city.
                  </p>

                  <p>
                    Through the great vision and scholarly skills of Maharaja
                    Sawai Jai Singh II and extensive works by his Chief
                    Architect Vidyadhar Bhattacharji, Jaipur rose to fame as the
                    most beautiful and the best planned place to live in.
                    Liberal, protective and secular policies of the rulers
                    attracted a wide range of artisans, artists and businessmen,
                    which today make this city, a great arts, crafts, trade and
                    cultural centre. Architecturally, the city proved to be a
                    milestone and other great kings like Sawai Ram Singh and
                    Sawai Mansingh II added many more public buildings and
                    institutions to this existing masterpiece.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bika Ki Tekri Old Fort{" "}
                  </h2>

                  <p>
                    In the amidst of the magical landscape that Rao Bika started
                    the construction of this fort in 1485 .Situated on the rocky
                    ground south west of the city, the fort preceded the city by
                    three years.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Junagarh Fort{" "}
                  </h2>
                  <p>
                    This fort was constructed by Rai Singh. The foundation of
                    the fort was laid down in the year 1589and the work was over
                    in 1594. The fort has a circumference of 985 meters. Being
                    on ground level, a moat was constructed around the fort as
                    security cordon. The fort complex is considered as an
                    architectural feat. The important portions of the fort are
                    Anup Mahal, Ganga Niwas, Durbar Hall, Har Mandir, Gaj
                    Mandir, Sheesh Mahal, Karan Mahal, Phool Mahal, Chandra
                    Mahal, Chini Burj etc. but Anup Mahal is the best place to
                    be viewed.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Lalgarh Palace
                  </h2>
                  <p>
                    The architectural masterpiece in red sandstone, the palace
                    was built by Maharaja Ganga Singh in the memory of his
                    father Maharaja Lal Singh. The palace has beautiful lattice
                    work and filigree work. Sprawling lawns with blooming
                    bougainvillea and dancing peacocks make it a not-to-be
                    missed visual treat. Part of the palace has been converted
                    into a luxury hotel and a museum known as Shri Sadul Museum.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Bikaner;
